import { DatePicker, Form, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ETag from "components/ETag";
import { SearchTable, useEndeavour } from "components/Endeavour";
import { ColoredStatistic, ISO8601 } from "components/Jarvis";
import dayjs from "dayjs";
import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { FloatMul } from "components/Jarvis";
import PaymentPage from "./PaymentPage";

const rangePresets = [
  {
    label: "Today",
    value: [dayjs(), dayjs()],
  },
  {
    label: "Yesterday",
    value: [dayjs().add(-1, "d"), dayjs().add(-1, "d")],
  },
  {
    label: "Last 7 Days",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "Last 14 Days",
    value: [dayjs().add(-14, "d"), dayjs()],
  },
  {
    label: "Last 30 Days",
    value: [dayjs().add(-30, "d"), dayjs()],
  },
  {
    label: "Last 90 Days",
    value: [dayjs().add(-90, "d"), dayjs()],
  },
];

// function useForceUpdate() {
//   const [value, setValue] = useState(0);
//   return () => setValue((c) => c + 1);
// }

export default function PaymentsPage() {
  // const forceUpdate = useForceUpdate();

  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(window.location.search);
  const [loading, setLoading] = useState(false);
  const [forceUpdate, setforceUpdate] = useState(0);
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dateRange = searchParams.get("range")?.split(",");
  const handleValues = {
    reference: searchParams.get("reference"),
    status: searchParams.get("status"),
    currency: searchParams.get("currency"),
    range: [
      dateRange?.[0] ? dayjs(dateRange[0], "YYYY-MM-DD") : null,
      dateRange?.[1] ? dayjs(dateRange[1], "YYYY-MM-DD") : null,
    ],
    timezone: timezone,
  };

  const handleFilters = (values) => {
    let data = {};
    console.log("value", values);
    const params = new URLSearchParams();
    let check = 0;
    for (let [k, v] of Object.entries(values)) {
      if (v === undefined || v === null) {
        check++;
        if (check === 4) {
          window.history.pushState(null, "", window.location.pathname);
          setQuery();
          break;
        }
        continue;
      }
      switch (k) {
        case "range":
          if (v?.[0] === null || v?.[1] === null) {
            continue;
          }
          const formated = v.map((date) => date.format("YYYY-MM-DD"));
          params.set("range", `${formated[0]},${formated[1]}`);
          data["range"] = [formated[0], formated[1]];
          break;
        default:
          params.set(k, v);
          data[k] = v;
      }
      params.set("timezone", timezone);
      data["timezone"] = timezone;
      let string = params.toString();
      window.history.pushState(
        null,
        "",
        window.location.pathname + (string ? "?" : "") + string
      );
      console.log("string", string);
      setQuery("?" + string);
    }
    setforceUpdate((forceUpdate) => forceUpdate + 1);
  };

  // useEffect(() => {
  //   forceUpdate();
  // }, [query]);

  //new
  const endeavour = useEndeavour();

  // const handleQuickActionClick = (paymentId) => {
  //   openDrawer({
  //     // title: `Payment Details for ${paymentId}`,
  //     content: <PaymentPage pID={paymentId} />,
  //     width: 1000,
  //     placement: "right",
  //     // footer: <div>Powered by PAYPLUS LIMITED</div>,
  //   });
  // };

  return (
    <SearchTable
      title="Payments"
      allowExport
      searchFields={[
        <Form.Item label="Reference" name="reference">
          <Input />
        </Form.Item>,
        <Form.Item label="Date Range" name="range">
          <DatePicker.RangePicker presets={rangePresets} />
        </Form.Item>,
        <Form.Item label="Status" name="status">
          <Select allowClear>
            <Select.Option value="Created">Created</Select.Option>
            <Select.Option value="Pending">Pending</Select.Option>
            <Select.Option value="Processing">Processing</Select.Option>
            <Select.Option value="Completed">Completed</Select.Option>
            <Select.Option value="Expired">Expired</Select.Option>
          </Select>
        </Form.Item>,
        <Form.Item label="Currency" name="currency">
          <Select allowClear>
            <Select.Option value="HKD">HKD - Hong Kong Dollar</Select.Option>
            <Select.Option value="USD">USD - US Dollar</Select.Option>
            <Select.Option value="NZD">NZD - New Zealand Dollar</Select.Option>
          </Select>
        </Form.Item>,
      ]}
      name="payments"
      forceUpdate={forceUpdate}
      setLoading={setLoading}
      uri={`/gateway/resources/payments`}
      tableColumns={[
        {
          title: "Reference",
          render: (item) => {
            return (
              <Link to={`/payments/${item.id}`}>{item.order_reference}</Link>
            );
          },
          width: 270,
        },
        {
          title: "Type",
          align: "center",
          render: (item) => {
            const tags = item.types.map((element, index) => (
              <ETag key={index}>{element.toUpperCase()}</ETag>
            ));
            return <>{tags}</>;
          },
        },
        {
          title: "Date",
          align: "center",
          render: (item) => {
            return ISO8601(item.created_at);
          },
        },
        {
          title: "Status",
          align: "center",
          render: (item) => {
            return <ETag>{item.status}</ETag>;
          },
        },
        {
          title: "Order",
          align: "right",
          render: (item) => {
            return (
              <ColoredStatistic
                prefix={item.order_currency}
                value={item.order_amount}
              />
            );
          },
        },
        {
          title: "Quick Action",
          align: "center",
          width: 70,
          render: (item) => (
            <SearchOutlined
              onClick={() => {
                endeavour.openDrawer({
                  title: "Detail Preview",
                  width: "1000",
                  children: <PaymentPage pID={item.id} />,
                });
              }}
            />
          ),

          // <a>
          //   <div>
          //     <FaSearch onClick={() => handleQuickActionClick(item.id)} />
          //   </div>
          // </a>
        },
      ]}
      exportColumns={[
        {
          title: "Reference",
          render: (item) => {
            return item.order_reference;
          },
        },
        {
          title: "Type",
          align: "center",
          render: (item) => {
            return item.types;
          },
        },
        {
          title: "Date",
          align: "center",
          render: (item) => {
            return ISO8601(item.created_at);
          },
        },
        {
          title: "Status",
          align: "center",
          render: (item) => {
            return item.status;
          },
        },
        {
          title: "Order",
          align: "right",
          render: (item) => {
            return `${item.order_currency} ${FloatMul(item.order_amount, 1)}`;
          },
        },
      ]}
    />
  );
}
